import { derived, writable, type Writable, type Readable } from 'svelte/store';
import type { Models } from '@smartlinkdev/types';
import { get } from 'svelte/store';
import { locations, venue } from '$lib/stores';
import { activeLanguage } from '$lib/stores/languages';
import { SearchAPIService, type SearchServiceHit } from '$lib/services/search';

export const locationSearchQuery = writable<string | undefined>(undefined);

export const searchAndCategoryFiltered: Readable<Models.Location[]> = derived<[Writable<string | undefined>, Writable<Models.Location[]>, Writable<Models.Venue | undefined>], Models.Location[]>(
  [locationSearchQuery, locations, venue],
  ([$locationSearchQuery, $locations, $venue], set) => {
    (async () => {
      if (!$locationSearchQuery) {
        set($locations);
        return;
      }

      try {
        const language = get(activeLanguage);
        const searchService = new SearchAPIService($venue.id)
        const searchResults = await searchService.query($locationSearchQuery, language.id);
        const searchFilteredLocations = $locations
            .filter((loc) => searchResults.some((result) => result._source?.id === loc.id))
            .sort((a, b) => {
              const scoreA = searchResults.find((result) => result._source?.id === a.id)?._score || 0;
              const scoreB = searchResults.find((result) => result._source?.id === b.id)?._score || 0;
              return scoreB - scoreA;
        });
        set(searchFilteredLocations);
      } catch (e) {
        console.error('error using api search');
        set([]);
      }
    })();
  },
  [], // initial value
);
